var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartsLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 84,
    viewBox: "0 0 37 84",
    width: 37,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m12.5 36.4c8.5312 0 12.25-5.7428 12.25-19.6 0 13.8572 3.6925 19.6 12.25 19.6-8.5575 0-12.25 5.908-12.25 19.6 0-13.692-3.7188-19.6-12.25-19.6zm-10.5-23.8c5.4845 0 7.875-3.6904 7.875-12.6 0 8.9096 2.3748 12.6 7.875 12.6-5.5002 0-7.875 3.7996-7.875 12.6 0-8.8004-2.3905-12.6-7.875-12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 70.6c5.4845 0 7.875-3.6904 7.875-12.6 0 8.9096 2.3748 12.6 7.875 12.6-5.5002 0-7.875 3.7996-7.875 12.6 0-8.8004-2.3905-12.6-7.875-12.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartsLeft);
export default __webpack_public_path__ + "static/media/startsLeft.eb18b0dce74e49a5994a2672cc9b6999.svg";
export { ForwardRef as ReactComponent };